var render = function render(){var _vm=this,_c=_vm._self._c;return _c('li',{class:{ 'active-trail': _vm.active }},[_c('router-link',{class:{
      'sidebar__nav-bigtitle': true,
      'notification-dot': _vm.notification,
      'icon-challenges-nav-bar-icon': _vm.section.text === 'Modules',
      'icon-couchtraq': _vm.section.text === 'Traqing',
      'icon-rewards-nav-bar-icon': _vm.section.text === 'Rewards',
      'icon-social-nav-bar-icon': _vm.section.text === 'Social',
      'icon-profile-nav-bar-icon': _vm.section.text === 'Profile',
      'icon-check': _vm.section.text === 'Approve',
    },attrs:{"to":{
      name: _vm.route,
      params: _vm.params,
    }}},[_c('span',[_vm._v(_vm._s(_vm.section.text)+"\n      "),(_vm.stat)?_c('span',{staticClass:"number"},[_vm._v(_vm._s(_vm.stat))]):_vm._e()])]),_vm._v(" "),_c('ul',{staticClass:"sidebar__nav-sub"},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }